import { Text, View } from "react-native";
import { MedicationReportModel } from "app/services/api/types/medications/models/MedicationReportModel";

interface Props {
  medication: MedicationReportModel;
}

export default function MedicationLogContent({ medication }: Props) {
  return (
    <View className="flex-col w-fit">
      <Text className="text-base font-semibold">
        {medication.medication.name}
      </Text>
      <View className="flex-row flex-wrap items-center gap-x-3">
        <Text className="text-md text-typography-600">
          Dosage: {medication.medication.dosage}
        </Text>
      </View>
    </View>
  );
}
